module.exports = __webpack_public_path__ + "static/media/ic_box_arrow_up.1a78c3c5.svg";